import type { FunctionComponent, ReactNode } from 'react';

export type PromptShellProps = {
    readonly question: ReactNode;
    readonly leading?: ReactNode;
    readonly contextLine?: ReactNode;
    readonly actions?: ReactNode;
    readonly versionLabel?: ReactNode;
};

export const PromptShell: FunctionComponent<PromptShellProps> = ({
    question,
    leading,
    contextLine,
    actions,
    versionLabel,
}) => {
    const hasContextRow = leading != null || contextLine != null || actions != null;

    return (
        <div className="flex flex-col gap-m font-sans" style={{ padding: '14px 16px 12px' }}>
            <div className="flex flex-col gap-xs">
                {versionLabel}
                <p
                    className="m-0 text-black-900"
                    style={{
                        fontSize: '0.9375rem',
                        fontWeight: 500,
                        letterSpacing: '-0.0175em',
                        lineHeight: 1.3,
                    }}
                >
                    {question}
                </p>
            </div>

            {hasContextRow && (
                <div className="flex items-center gap-m">
                    <div className="flex min-w-0 flex-1 items-center gap-xs">
                        {leading}
                        {contextLine != null && (
                            <span className="min-w-0 truncate text-xxs font-medium text-gray-800">{contextLine}</span>
                        )}
                    </div>
                    {actions != null && <div className="flex shrink-0 items-center gap-xs">{actions}</div>}
                </div>
            )}
        </div>
    );
};
